import app from 'flarum/forum/app';
import highlight from 'flarum/common/helpers/highlight';
import Link from 'flarum/common/components/Link';
import {SearchSource} from 'flarum/forum/components/Search';
import Album from '../models/Album';
import {cimaiseAlbum} from '../routes';

const translationPrefix = 'kilowhat-cimaise.forum.album-search.';

export default class AlbumSearchSource implements SearchSource {
    results: {[query: string]: Album[]} = {};

    search(query: string) {
        query = query.toLowerCase();

        this.results[query] = [];

        return app.store.find<Album[]>('cimaise/albums', {
            filter: {q: query},
            page: {limit: 3},
        }).then(results => {
            this.results[query] = results;
        });
    }

    view(query: string) {
        query = query.toLowerCase();

        const results = this.results[query] || [];

        return [
            m('li.Dropdown-header', app.translator.trans(translationPrefix + 'title')),
            results.map(album => {
                const coverPicture = album.coverPicture();

                return m('li.AlbumSearchResult', {
                    'data-index': 'albums' + album.id(),
                }, [
                    m(Link, {
                        href: cimaiseAlbum(album),
                    }, m('.DiscussionSearchResult-title', [
                        coverPicture ? m('img', {
                            src: coverPicture.imageUrl(150),
                        }) : m('.ImagePlaceholder'),
                        highlight(album.title(), query)
                    ])),
                ]);
            }),
        ];
    }
}
